// @flow
import { LayoutHintConfiguration } from "./LayoutHintConfig";

/**
 * Retrieve layout hint by id from the layout hint configuration
 */
const getHint = (hint: string): string => {
  if (LayoutHintConfiguration[hint]) {
    return LayoutHintConfiguration[hint].hint;
  }

  return "";
};

/**
 * Layout-hint: Indicates a mandatory attribute. Should be used together with the dependency hint.
 */
export const MANDATORY: string = getHint("MANDATORY");

/**
 * Layout-hint: Indicates a disabled attribute.
 * @constant
 */
export const DISABLED: string = getHint("DISABLED");

/*
 * --------------------------------
 * SELECT DEPENDENT ATTRIBUTES
 * --------------------------------
 */
/**
 * Layout-hint: Marks the choice attribute where other attributes depend on. The unique control id is a unique id that can be used in the hint for the show|hide action on the dependent attribute.
 */
export const DEPENDENT_ATTRIBUTE_CONTROL = "dependent-control";
/**
 */
export const DEPENDENT_ATTRIBUTE = "dependent-attribute:";

/*
 * --------------------------------
 * ATTRIBUTES
 * --------------------------------
 */
/**
 * Layout-hint: Password attribute must be confirmed using a second password attribute.
 */
export const CONFIRM_PASSWORD: string = getHint("CONFIRM_PASSWORD");
/**
 * Layout-hint: Sort options alphabetically
 */
export const SORT_OPTIONS: string = getHint("SORT_OPTIONS");
/**
 * Layout-hint: Marks an attribute as a title attribute
 */
export const TITLE: string = getHint("TITLE");

/*
 * --------------------------------
 * FORM
 * --------------------------------
 */
/**
 * Layout-hint: Mark task as delete task
 */
export const DELETE_ACTION: string = getHint("DELETE_ACTION");
/**
 * Layout-hint: Mark task as update task
 */
export const UPDATE_ACTION: string = getHint("UPDATE_ACTION");
/**
 * Layout-hint: Mark task as create task
 */
export const CREATE_ACTION: string = getHint("CREATE_ACTION");

/*
 * --------------------------------
 * UPLOAD TOTAL FILE SIZE
 * --------------------------------
 */
/**
 * Layout-hint: Used in conjunction with an upload attribute, this hint is set on a read only attribute containing the file size currently used.
 */
export const INITIAL_TOTAL_FILESIZE: string = getHint("INITIAL_TOTAL_FILESIZE");
/**
 * Layout-hint: Used in conjunction with an upload attribute, this hint is set on a read only attribute containing the maximum allowed total file size.
 */
export const MAX_TOTAL_FILESIZE: string = getHint("MAX_TOTAL_FILESIZE");

/*
 * --------------------------------
 * LISTS
 * --------------------------------
 */
/**
 * Layout-hint: A list with only one detail must be shown as a detail
 */
export const SHOW_ONE_RESULT_AS_DETAIL: string = getHint(
  "SHOW_ONE_RESULT_AS_DETAIL",
);
/**
 * Layout-hint: A list without list-items and list-tasks should not be shown.
 */
export const HIDE_WHEN_EMPTY: string = getHint("HIDE_WHEN_EMPTY");
/**
 * Layout-hint: Sets a default value on a filter
 */
export const INITIAL_FILTER: string = "initial-filter:";
/**
 * Layout-hint: Mark a case id reference attribute as the reference to the case view. Replaces the self link of a list item
 */
export const CASEVIEW_LINK: string = getHint("CASEVIEW_LINK");

/**
 * Layout-hint: Set on configuration of instruments to show content in a popover on a label
 */
export const RENDER_SECTION_LABEL = "render-section-label";

/**
 * Layout-hint: Hide a link to a component
 */
export const HIDE_IN_USER_INTERFACE: string = getHint("HIDE_IN_USER_INTERFACE");

/**
 */
export const getLayoutHintConfiguration = (): Object => LayoutHintConfiguration;

/**
 * Layout-hint: Marks an attribute as an avatar for the title attribute.
 */
export const AVATAR_IN_TITLE: string = getHint("AVATAR_IN_TITLE");

export const AVATAR: string = getHint("AVATAR");

export default getHint;
